import Vue from "vue/dist/vue.common.js";
import "./validation/validation";

import PriceCalculator from "../components/price-calculator.vue";
import QuantityField from "../components/quantity-field.vue";

new Vue({
    el: "#mass-product",
    components: {
        PriceCalculator,
    }
});

if (document.querySelector(".buy-accessory") !== null) {
    new Vue({
        el: ".buy-accessory",
        components: {
            QuantityField
        }
    })
}

$('#go-to-mass-calculator').click(function (e) {
    e.preventDefault();
    $('.nav-item a[href="#mass-calculator"]').tab('show');
})